import { Credentials } from './credentials';

export class User {
  private readonly _credentials: Credentials;
  private readonly _isAdmin: boolean;

  constructor(credentials: Credentials, isAdmin: boolean) {
    this._credentials = credentials;
    this._isAdmin = isAdmin;
  }

  get credentials(): Credentials {
    return this._credentials;
  }

  get isAdmin(): boolean {
    return this._isAdmin;
  }
}

export class UserProfile {
  private readonly _login: string;

  static get EMPTY(): UserProfile {
    const res = new UserProfile('');
    res.features = {};
    return res;
  }

  constructor(login: string) {
    this._login = login;
  }

  lastLogin: Date;
  features: any = null;

  get login(): string {
    return this._login;
  }

  get asString(): string {
    if (!!this.features && this.features !== null && !!this.features.asString) {
      return this.features.asString;
    } else {
      return this.login;
    }
  }
}

export abstract class UserFeaturesTemplateProvider {
  abstract getUserFeaturesTemplate(): any;
}
